import { AttachmentFile } from "../../expenses/models/attachement-file.model";
import { hcpClass } from "./hcpClass.model";
import { ItemBrand } from "./item-brand.model";
 
export class HCP {

  constructor() {
    this.active = true;
    this.id = 0;
  }
  id: number;
  Id: number;
  firstName: string;
  arabicName: string;
  middleName: string;
  lastName: string;
  nickName: string;
  fullName: string;
  specialityId: number;
  classId: number;
  itemBrandId: number;
  class: hcpClass;
  itemBrand: ItemBrand;


  active: boolean;
  selected: boolean;


  specialityName: string;
  hcpClassName: string;

  email: string;
  phone: string;
  otp: string;

  trimmedName: string;
  trimmedEmail: string;
  goldenList: boolean;
  hcoIds: Number[];
  isApproved: boolean;
  editRequestId: number;
  createdByName: string;
  files: AttachmentFile[];
}
